// extracted by mini-css-extract-plugin
export default {"wrapper":"PurchaseParkingPage_wrapper__MkoOV","content_wrapper":"PurchaseParkingPage_content_wrapper__GJf5L","content":"PurchaseParkingPage_content__FWvmq"};